import React from 'react'
import { useMutation } from 'react-query'
import * as Sentry from '@sentry/react'
import { postUploadImageToCloudinary } from '../api'

const useUploadImageToCloudinary = () =>
    useMutation(postUploadImageToCloudinary, {
        onSuccess: (data) => {
            if (!data) {
                Sentry.captureMessage('Cloudinary image upload failed.', {
                    level: Sentry.Severity.Critical,
                    extra: {
                        responseValue: JSON.stringify(data, null, 2),
                    },
                })
            }
        },
        onError: (error, context) => {
            Sentry.captureMessage(
                'Cloudinary image upload failed. Possible reasons: Cloudinary is down or account balance finished',
                {
                    level: Sentry.Severity.Critical,
                }
            )
        },
    })

export default useUploadImageToCloudinary
